import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3120CustomerEmployeeRateHandler } from "./U3120CustomerEmployeeRateHandlers";
import type { U3120CustomerEmployeeRate } from "../../../../U3120Service";

// Typage des props du composant
interface U3120CustomerEmployeeRateDeleteDlgProps {
  u3120CustomerEmployeeRateHandler: U3120CustomerEmployeeRateHandler;
  t: TFunction;
  NS: string;
}

function U3120CustomerEmployeeRateDeleteDlg({ u3120CustomerEmployeeRateHandler, t, NS }: U3120CustomerEmployeeRateDeleteDlgProps) {
  if (!u3120CustomerEmployeeRateHandler.isDeleteDialogOpen) return null;

  const getEmployeeDisplay = (rate: U3120CustomerEmployeeRate) => {
    if (!rate.employee) return rate.id || "";
    const parts = [];
    if (rate.employee.codeEmployee) parts.push(rate.employee.codeEmployee);
    if (rate.employee.firstName || rate.employee.lastName) {
      parts.push(`${rate.employee.firstName || ""} ${rate.employee.lastName || ""}`.trim());
    }
    return parts.length > 0 ? parts.join(" - ") : rate.employee.id || "";
  };

  return (
    <U2000DeleteRecordDialog isOpen={u3120CustomerEmployeeRateHandler.isDeleteDialogOpen} onClose={u3120CustomerEmployeeRateHandler.onDlgDeleteClose} title={t("lblCustomerEmployeeRate", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteCustomerEmployeeRate", {
          count: u3120CustomerEmployeeRateHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u3120CustomerEmployeeRateHandler.gridStateHandlers.getSelectedRows().map((row: U3120CustomerEmployeeRate, index: number, array: U3120CustomerEmployeeRate[]) => (
          <span key={row.id} className="inline-block text-gray-800">
            {getEmployeeDisplay(row)}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3120CustomerEmployeeRateDeleteDlg;
